export default __webpack_public_path__ + "static/media/slider-arrow-right.f7d1748f.svg";